const sanitizeParticipants = (participants = []) =>
  participants.filter((p) => {
    const hasName = p.name?.trim() !== '';
    const hasPhone = p.phone_number?.trim() !== '';
    const hasType = p.type?.trim() !== '';

    // hanya simpan kalau ada nama / phone
    return hasName || hasPhone || (hasType && (hasName || hasPhone));
  });

export { sanitizeParticipants };
